import React from 'react'
import { Link } from 'react-router-dom'
import '../App.css'

function EULA() {
  return (
    <div className='privacy-policy-container'>
      <div className='privacy-policy-nav'>
        <Link to='/' className='privacy-back-link'>← Back to Home</Link>
      </div>
      <div className='privacy-policy-content'>
        <h1>End User License Agreement (EULA)</h1>
        <p className='last-updated'>Last Updated: {new Date().toLocaleDateString()}</p>
        
        <section className='privacy-section'>
          <h2>1. Introduction</h2>
          <p>
            Welcome to Fashioniste ("we," "our," or "us"). This End User License Agreement (EULA) governs 
            your use of the Fashioniste application and establishes the rules of behavior for all users. 
            By accessing or using Fashioniste, you agree to comply with and be bound by these terms. If you 
            do not agree with any part of these terms, please do not use our application.
          </p>
        </section>

        <section className='privacy-section'>
          <h2>2. Rules of Behavior</h2>
          <p>
            Fashioniste is a community platform for sharing fashion content and OOTD (Outfit of the Day) posts. 
            To maintain a safe, respectful, and positive environment for all users, you must adhere to 
            the following rules of behavior:
          </p>
        </section>

        <section className='privacy-section'>
          <h2>3. Acceptable Content and Behavior</h2>
          <p>You are allowed to post and share:</p>
          <ul>
            <li><strong>Fashion Content:</strong> Outfit photos, style inspiration, fashion tips, and 
            related fashion content that is appropriate and respectful.</li>
            <li><strong>Personal Style:</strong> Your own OOTD posts, style journals, and fashion 
            preferences.</li>
            <li><strong>Constructive Comments:</strong> Respectful and constructive feedback, 
            compliments, and fashion-related discussions.</li>
            <li><strong>Original Content:</strong> Content that you own or have the right to share, 
            including photos you have taken or created.</li>
            <li><strong>Respectful Interactions:</strong> Positive and supportive interactions with 
            other users in the community.</li>
          </ul>
        </section>

        <section className='privacy-section'>
          <h2>4. Prohibited Content and Behavior</h2>
          <p>The following content and behaviors are strictly forbidden on Fashioniste:</p>
          
          <h3>4.1 Explicit and Inappropriate Content</h3>
          <ul>
            <li><strong>No Nudity:</strong> Nudity, sexually explicit content, or pornographic 
            material of any kind is strictly prohibited.</li>
            <li><strong>No Inappropriate Images:</strong> Content that is sexually suggestive, 
            contains partial nudity, or is otherwise inappropriate for a general audience.</li>
            <li><strong>No Adult Content:</strong> Any content intended for adult audiences only.</li>
          </ul>

          <h3>4.2 Harassment and Bullying</h3>
          <ul>
            <li><strong>No Harassment:</strong> Harassing, stalking, threatening, or intimidating 
            other users is strictly prohibited.</li>
            <li><strong>No Bullying:</strong> Bullying, trolling, or making personal attacks against 
            other users is not allowed.</li>
            <li><strong>No Cyberbullying:</strong> Any form of online harassment, including but not 
            limited to spreading rumors, posting hurtful comments, or targeting individuals.</li>
            <li><strong>No Doxxing:</strong> Sharing private or personal information about other users 
            without their consent is prohibited.</li>
          </ul>

          <h3>4.3 Hate Speech and Discrimination</h3>
          <ul>
            <li><strong>No Hate Speech:</strong> Content that promotes hatred, violence, or 
            discrimination against individuals or groups based on race, ethnicity, religion, gender, 
            sexual orientation, disability, or any other protected characteristic is strictly 
            prohibited.</li>
            <li><strong>No Discriminatory Content:</strong> Any content that discriminates against, 
            marginalizes, or excludes individuals or groups.</li>
            <li><strong>No Extremist Content:</strong> Content that promotes extremist ideologies or 
            violent extremism.</li>
          </ul>

          <h3>4.4 Illegal Activities</h3>
          <ul>
            <li><strong>No Illegal Content:</strong> Content that promotes, depicts, or encourages 
            illegal activities is prohibited.</li>
            <li><strong>No Copyright Infringement:</strong> Posting content that infringes on 
            intellectual property rights, including copyrighted material, without proper authorization.</li>
            <li><strong>No Fraudulent Activity:</strong> Any attempt to deceive, defraud, or scam 
            other users is strictly prohibited.</li>
          </ul>

          <h3>4.5 Spam and Misleading Content</h3>
          <ul>
            <li><strong>No Spam:</strong> Repetitive, unwanted, or unsolicited content, including 
            excessive posting, chain messages, or promotional spam.</li>
            <li><strong>No Misleading Information:</strong> Content that is false, misleading, or 
            designed to deceive users.</li>
            <li><strong>No Impersonation:</strong> Impersonating other users, celebrities, brands, or 
            entities is not allowed.</li>
          </ul>

          <h3>4.6 Violence and Harmful Content</h3>
          <ul>
            <li><strong>No Violence:</strong> Content that depicts, promotes, or glorifies violence, 
            self-harm, or harm to others.</li>
            <li><strong>No Dangerous Activities:</strong> Content that encourages dangerous or 
            harmful activities.</li>
            <li><strong>No Graphic Content:</strong> Graphic, disturbing, or gory content that 
            may be harmful to viewers.</li>
          </ul>
        </section>

        <section className='privacy-section'>
          <h2>5. Content Moderation and Removal</h2>
          <p>
            We reserve the right, but not the obligation, to monitor, review, and moderate all content 
            posted on Fashioniste. We may remove or delete any content that violates these terms, including 
            but not limited to:
          </p>
          <ul>
            <li>Content that violates any of the prohibited behaviors listed above</li>
            <li>Content that we determine, in our sole discretion, to be inappropriate, harmful, or 
            offensive</li>
            <li>Content that violates applicable laws or regulations</li>
            <li>Content that infringes on the rights of others</li>
            <li>Content that disrupts the user experience or community environment</li>
          </ul>
          <p>
            <strong>Content Removal:</strong> We may remove content immediately and without prior 
            notice if we determine it violates these terms. Removed content may be permanently 
            deleted from our systems.
          </p>
        </section>

        <section className='privacy-section'>
          <h2>6. Account Suspension and Termination</h2>
          <p>
            Violation of these terms may result in disciplinary action, including but not limited to:
          </p>
          
          <h3>6.1 Warning System</h3>
          <ul>
            <li>First-time violations may result in a warning and removal of the offending content.</li>
            <li>Repeated violations may result in temporary restrictions on your account.</li>
          </ul>

          <h3>6.2 Account Suspension</h3>
          <ul>
            <li><strong>Temporary Suspension:</strong> Your account may be temporarily suspended for 
            a specified period, during which you will not be able to access or use the application.</li>
            <li><strong>Permanent Suspension:</strong> Severe or repeated violations may result in 
            permanent suspension of your account.</li>
            <li><strong>Suspension Duration:</strong> The duration of suspension will be determined 
            by us based on the severity and frequency of violations.</li>
          </ul>

          <h3>6.3 Account Termination</h3>
          <ul>
            <li><strong>Permanent Ban:</strong> Accounts that engage in severe violations, including 
            but not limited to hate speech, harassment, illegal activities, or repeated violations 
            after warnings, may be permanently banned.</li>
            <li><strong>Immediate Termination:</strong> We reserve the right to immediately terminate 
            accounts that engage in particularly egregious violations without prior warning.</li>
            <li><strong>No Refund:</strong> Account termination does not entitle you to any refund 
            of fees paid, if applicable.</li>
          </ul>

          <h3>6.4 Appeals Process</h3>
          <p>
            If you believe your account was suspended or terminated in error, you may contact us to 
            appeal the decision. However, our decision regarding account actions is final and at our 
            sole discretion.
          </p>
        </section>

        <section className='privacy-section'>
          <h2>7. User Responsibilities</h2>
          <p>As a user of Fashioniste, you are responsible for:</p>
          <ul>
            <li>Ensuring all content you post complies with these terms and applicable laws</li>
            <li>Respecting the rights and dignity of other users</li>
            <li>Reporting content or behavior that violates these terms</li>
            <li>Maintaining the security of your account credentials</li>
            <li>Using the application in a lawful and appropriate manner</li>
          </ul>
        </section>

        <section className='privacy-section'>
          <h2>8. Reporting Violations</h2>
          <p>
            If you encounter content or behavior that violates these terms, please report it to us 
            immediately through the reporting features available in the application or by contacting 
            us directly. We take all reports seriously and will investigate them promptly.
          </p>
          <p>
            When reporting, please provide:
          </p>
          <ul>
            <li>A description of the violation</li>
            <li>Links to or screenshots of the offending content</li>
            <li>Any relevant context or information</li>
          </ul>
        </section>

        <section className='privacy-section'>
          <h2>9. Our Rights and Discretion</h2>
          <p>
            We reserve the right, in our sole discretion, to:
          </p>
          <ul>
            <li>Remove, edit, or delete any content at any time for any reason</li>
            <li>Suspend or terminate user accounts that violate these terms</li>
            <li>Modify, update, or change these terms at any time</li>
            <li>Take any action we deem necessary to maintain the safety and integrity of the 
            platform</li>
            <li>Cooperate with law enforcement authorities when required by law</li>
            <li>Disclose user information when necessary to enforce these terms or comply with legal 
            obligations</li>
          </ul>
        </section>

        <section className='privacy-section'>
          <h2>10. Intellectual Property</h2>
          <p>
            By posting content on Fashioniste, you grant us a license to use, display, and distribute your 
            content in connection with the operation of the application. You retain ownership of your 
            content, but you represent and warrant that you have the right to grant this license and 
            that your content does not infringe on the rights of any third party.
          </p>
        </section>

        <section className='privacy-section'>
          <h2>11. Changes to These Terms</h2>
          <p>
            We may update these terms from time to time to reflect changes in our practices, legal 
            requirements, or for other reasons. We will notify you of any material changes by posting 
            the updated terms on this page and updating the "Last Updated" date. Your continued use 
            of Fashioniste after such changes constitutes your acceptance of the updated terms.
          </p>
        </section>

        <section className='privacy-section'>
          <h2>12. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, we are not liable for any damages arising from 
            your use of Fashioniste, including but not limited to content removal, account suspension, or 
            termination. We do not guarantee that all content will be monitored or that violations 
            will be detected immediately.
          </p>
        </section>

        <section className='privacy-section'>
          <h2>13. Contact Us</h2>
          <p>
            If you have any questions about this EULA, wish to report a violation, or need to appeal 
            an account action, please contact us:
          </p>
          <ul>
            <li>Email: baralnishan987@gmail.com</li>
            <li>Through the contact form on our website</li>
          </ul>
        </section>

        <section className='privacy-section'>
          <h2>14. Acknowledgment</h2>
          <p>
            By using Fashioniste, you acknowledge that you have read, understood, and agree to be bound by 
            these terms. You understand that violation of these terms may result in content removal, 
            account suspension, or permanent ban from the platform. If you do not agree with these 
            terms, please do not use our application.
          </p>
        </section>
      </div>
    </div>
  )
}

export default EULA



